import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=716e3526&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=ts"
export * from "./Categories.vue?vue&type=script&lang=ts"
import style0 from "./Categories.vue?vue&type=style&index=0&id=716e3526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716e3526",
  null
  
)

export default component.exports